import React from 'react';

import CTA from '../../../components/CTA';

const CTABlock = ({ entity }) => {
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'value'], '');
  const link = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri'], ''));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');
  const linkTarget = entity.getIn(['field_link', 0, 'options', 'attributes', 'target'], '_self');
  const secondaryLink = entity.getIn(['field_link', 1, 'alias'], entity.getIn(['field_link', 1, 'uri'], ''));
  const secondaryLinkTitle = entity.getIn(['field_link', 1, 'title'], '');
  const secondaryLinkTarget = entity.getIn(['field_link_secondary', 0, 'options', 'attributes', 'target'], '_self');
  const large = entity.getIn(['field_large', 0, 'value'], false);
  const imageStyles = entity.getIn(['field_image', 0, 'styles']);

  return (
    <CTA
      title={title}
      body={body}
      link={link}
      linkTitle={linkTitle}
      linkTarget={linkTarget}
      secondaryLink={secondaryLink}
      secondaryLinkTitle={secondaryLinkTitle}
      secondaryLinkTarget={secondaryLinkTarget}
      small={!large}
      imageStyles={imageStyles}
    />
  );
};

export default CTABlock;
